export default "__VITE_ASSET__CHvWBqW$__"